// UAE Pass Authentication Module
// Provides complete UAE Pass integration for React Native with Expo

// Types
export type {
    UAEPassUser,
    UAEPassTokenResponse,
    UAEPassAuthResult,
    UAEPassConfig,
    UAEPassAuthParams
} from './types';

// Services
export { uaePassService } from './services/uaePassService';

// Hooks
export { useUAEPass } from './hooks/useUAEPass';
export type { UseUAEPassReturn } from './hooks/useUAEPass';

// Components
export { UAEPassAuth } from './components/UAEPassAuth';
export type { UAEPassAuthProps } from './components/UAEPassAuth';

export { UAEPassWebView } from './components/UAEPassWebView';
export type { UAEPassWebViewProps } from './components/UAEPassWebView';

// Default export for convenience
export { UAEPassAuth as default } from './components/UAEPassAuth';